var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondCartOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".85vw",
    height: ".85vw",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63223 3.51093L7.75262 8.38083L10.9992 18.4891M10.9992 18.4891L14.3313 8.29539L12.5371 3.51093M10.9992 18.4891L2.19922 8.46627M10.9992 18.4891L19.7992 8.46627M2.19922 8.46627L5.95844 3.51093H16.1254L19.7992 8.46627M2.19922 8.46627H19.7992",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondCartOrder);
export default __webpack_public_path__ + "static/media/diamondCartOrder.7113dc399ac272d10fca85fb06cea4e0.svg";
export { ForwardRef as ReactComponent };